/* eslint-disable no-return-assign */
import React, { useEffect, useRef } from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import { handleKeyboardEventBehavior, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { renderLinkedComponents } from "@qlik/qlik/src/components/registry";

import * as styles from "./styles.module.css";

const MultiAccordion = ({ data }) => {
    const { title, eyebrowText, subtitle, additionalConfiguration, customId, id, multiItems = [], itemLabels = [] } =
        data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const accordionRefs = useRef([]);
    const toggleAccordion = (index) => {
        const accordionItem = accordionRefs.current[index];
        accordionItem.classList.toggle(styles.active);
    };

    useEffect(() => {
        accordionRefs.current[0].classList.add(styles.active);
    }, []);

    return (
        <section className={`${sectionSpacingClassName}`} data-section id={getTransformedId(customId) ?? id}>
            <div className="container">
                {(eyebrowText || title || subtitle) && (
                    <div className="mb-7 md:mb-14.5">
                        {eyebrowText && (
                            <p className="text-ocean leading-none tracking-wide5 tag-1 mb-5">{eyebrowText}</p>
                        )}
                        {title && (
                            <h2
                                className={`${styles.cardTitles} mb-5`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        )}
                        {subtitle && (
                            <p
                                className={`${styles.cardTitles} text-md lg:text-2xl leading-relaxed tracking-tight6 font-light`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }}
                            />
                        )}
                    </div>
                )}
                {multiItems?.map((item, index) => (
                    <div
                        className={`${styles.accordion} rounded bg-white  box-border`}
                        key={item?.id}
                        ref={(el) => {
                            accordionRefs.current[index] = el;
                        }}
                    >
                        <div
                            className={`px-7.5 py-5 relative cursor-pointer inline-block w-full text-gray md:text-2xl font-normal leading-relaxed tracking-tight6 ${styles.accordionTitle}`}
                            role="button"
                            onClick={() => toggleAccordion(index)}
                            tabIndex={-1}
                            onKeyDown={(e) => {
                                handleKeyboardEventBehavior(e, () => toggleAccordion(index));
                            }}
                        >
                            <span className="inline-block pr-15">{itemLabels?.[index] || item?.title}</span>
                            <span className={styles.accordionIcon}></span>
                        </div>

                        <div className={`${styles.bodySection} `}>{renderLinkedComponents(item)}</div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default MultiAccordion;
